import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi } from '@shared/api/rest';
import type { RecipientCreateRequest, RecipientResponse } from '@shared/api/rest/recipients';

const effect = createEffect((request: RecipientCreateRequest) => RecipientsApi.create(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(effect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $recipientCreateStore = {
  events: {
    create: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
